<template>
<div>
    <accounting-books-receipt-form :subsidiaryLedgerId="subsidiaryLedgerId" ref="accountingBooksReceiptFormModal"></accounting-books-receipt-form>
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2 mb-1">
                <label for="start-date-input">{{ $t('accountingTransactionDoesntTransferedRecordsReport.start_date') }}</label>
                <CustomDatePicker :datePickerValidateOption="0" v-model="startDate" @input="getAccountingTransactionDoesntTransferedRecordsReportList()"></CustomDatePicker>
            </b-col>
            <b-col class="col-md-2 mb-1">
                <label for="end-date-input">{{ $t('accountingTransactionDoesntTransferedRecordsReport.end_date') }}</label>
                <CustomDatePicker :datePickerValidateOption="0" v-model="endDate" @input="getAccountingTransactionDoesntTransferedRecordsReportList()"></CustomDatePicker>
            </b-col>
            <b-col class="col-md-2 mb-1">
                <label for="accounting-transaction-type-input">{{ $t('accountingTransactionDoesntTransferedRecordsReport.accounting_transaction_type') }}</label>
                <b-form-select size="sm" v-model="accountingTransactionTypeSelect" value-field="id" text-field="name" :options="accountingTransactionTypeOption" @change="getAccountingTransactionDoesntTransferedRecordsReportList()" />
            </b-col>
            <b-col class="col-md-6 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" @click="getAccountingTransactionDoesntTransferedRecordsReportList()">{{ $t('others.list') }}</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table ref="accountingTransactionDoesntTransferedRecordsReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
                      enabled: false,
                      externalQuery: searchTerm }" :select-options="{
                      enabled: false,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                      disableSelectInfo: true, // disable the select info panel on top
                      selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                    }" :pagination-options="{
                      enabled: true,
                      perPage:pageLength
                    }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field ==='accountingTransactionType'" class="text-nowrap">
                {{ $t('accountingTransactionDoesntTransferedRecordsReport.accounting_transaction_type') }}
            </span>
            <span v-else-if="props.column.field ==='documentNo'" class="text-nowrap">
                {{ $t('accountingTransactionDoesntTransferedRecordsReport.document_no') }}
            </span>
            <span v-else-if="props.column.field === 'documentDate'" class="text-nowrap">
                {{ $t('accountingTransactionDoesntTransferedRecordsReport.document_date') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getAccountingTransactionDoesntTransferedRecordsReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            total: 0,
            pageLength: 10,
            searchTerm: '',
            dir: false,
            pageNo: 1,
            name: '',
            startDate: null,
            endDate: null,
            rows: [],
            columns: [{
                    label: this.$t('accountingTransactionDoesntTransferedRecordsReport.document_no'),
                    field: `documentNo`,
                },
                {
                    label: this.$t('accountingTransactionDoesntTransferedRecordsReport.document_date'),
                    field: `documentDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('accountingTransactionDoesntTransferedRecordsReport.accounting_transaction_type'),
                    field: `accountingTransactionType`,
                },
                // {
                //     label: 'Process',
                //     field: 'process',
                //     width: '10em'
                // },
            ],
            accountingTransactionTypeSelect: 0,
            accountingTransactionTypeOption: [],
        }

    },
    props: {
        subsidiaryLedgerId: {
            type: Number
        }
    },
    mounted() {
        this.getAccountingTransactionDoesntTransferedRecordsReportList();
    },
    methods: {
        getAccountingTransactionDoesntTransferedRecordsReportList() {
            this.rows = []
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'GetAccountingTransactionDoesntTransferedRecordsReport'
            }
            const data = {
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                startDate: this.startDate,
                endDate: this.endDate,
                subsidiaryLedgerId: this.subsidiaryLedgerId,
                accountingTransactionTypeId: this.accountingTransactionTypeSelect,
            }
            const payload = {
                data: data,
                controller: controller
            }

            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.accountingTransactionDoesntTransferedRecordsReportList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.total = response.data.total
                    this.accountingTransactionTypeOption = response.data.accountingTransactionTypeList
                    this.accountingTransactionTypeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async getInfo(id) {

            //TODO payment form or Official Fee Form or Invoice Form i d k.
            //this.$refs.accountingBooksReceiptFormModal.showInfo(id)
        },
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
